import { Children, ReactElement, cloneElement } from 'react';

import { numberUtils } from '@pukka/common/utils';
import { Shimmer, Text } from '@pukka/ui-components';
import { twMerge } from 'tailwind-merge';

interface SummaryHeaderItemProps {
  readonly title: string;
  readonly sum: number;
  readonly inCurrencyFormat?: boolean;
  readonly loading?: boolean;
  readonly className?: string;
}

interface SummaryHeaderProps {
  readonly children: ReactElement<SummaryHeaderItemProps>[];
  readonly loading?: boolean;
  readonly className?: string;
}

function SummaryHeader({ loading, children, className }: SummaryHeaderProps) {
  return (
    <div className={twMerge('flex flex-row rounded-md border border-neutral-300', className)}>
      {Children.map(children, (child) => {
        return cloneElement(child, {
          loading,
          ...child.props,
        });
      })}
    </div>
  );
}

function SummaryHeaderItem({ loading, title, sum, inCurrencyFormat, className }: SummaryHeaderItemProps) {
  return (
    <div className={twMerge('flex flex-1 flex-col items-center justify-center p-5', className)}>
      {loading ? (
        <Shimmer size="lg" className="mb-1 w-11" />
      ) : (
        <Text as="h4" variant="title-1" color="secondary" weight="bold" className="mb-2">
          {inCurrencyFormat ? numberUtils.formatCurrency(sum, 'Rp.') : numberUtils.formatCurrency(sum)}
        </Text>
      )}
      {loading ? (
        <Shimmer size="sm" className="w-28" />
      ) : (
        <Text as="h5" variant="caption-1" color="neutral">
          {title}
        </Text>
      )}
    </div>
  );
}

SummaryHeader.Item = SummaryHeaderItem;

export { SummaryHeader };
